import { render, staticRenderFns } from "./IconSmile.vue?vue&type=template&id=48d2d386&"
import script from "./IconSmile.vue?vue&type=script&lang=js&"
export * from "./IconSmile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports